import PaginatedList from "#root/components/paginated-list";
import type { ReactNode } from "react";
import { Fragment, useMemo } from "react";
import { getTrackingCollectionForSlug } from "#root/schema/platform/newsrpm-tracking";
import PageLayout from "../layout";

export default function BillingInvoicesPage({ slug }): ReactNode {
  const collection = useMemo(() => getTrackingCollectionForSlug(slug), [slug]);
  return (
    <PageLayout title="Tracking Report">
      <section>
        <h1>Article Tracking</h1>
        <p>View the distribution of this article across syndication networks and partner sites.</p>
        <PaginatedList title="Tracking Report" collection={collection} allowSearch={false}>
          {({ rows }) => (
            <table className="tracking-report">
              <tbody>
              {rows.map(
                ({ networkCode, network, sites }) =>
                  sites && (
                    <Fragment>
                      <tr key={"divider-" + networkCode}>
                        <td colSpan={1} className="label-divider">
                          Network: {network?.name ?? networkCode}
                        </td>
                        <td colSpan={1} className="label-divider" style={{ textAlign: "right" }}>
                          {sites.length} Sites
                        </td>
                      </tr>
                      <tr key={"header-" + networkCode}>
                        <th>Site Name</th>
                        <th>Article Link</th>
                      </tr>
                      {sites.map(({ name, url, headline, link }) => (
                        <tr key={name}>
                          <td>
                            {url ? (
                              <a target="_blank" href={url} rel="noopener">
                                {name}
                              </a>
                            ) : (
                              name
                            )}
                          </td>
                          <td>
                            {link ? (
                              <a target="_blank" href={link} rel="noopener">
                                {headline}
                              </a>
                            ) : (
                              headline
                            )}
                          </td>
                        </tr>
                      ))}
                    </Fragment>
                  ),
              )}
              </tbody>
            </table>
          )}
        </PaginatedList>
      </section>
    </PageLayout>
  );
}
